import { Processo } from "@/modelo";

export function filtrarPorOjc(processos: Processo[], ojc?: string | string[]) {
    if (!ojc) return processos;

    let listaOjc: string[] = [];

    if (Array.isArray(ojc)) {
        listaOjc = ojc.map(item =>
            item.trim().toUpperCase() === 'SEM_OJC'
                ? 'Sem OJC cadastrado'
                : item.trim()
        );
    } else if (typeof ojc === 'string') {
        listaOjc = ojc
            .split(',')
            .map(item =>
                item.trim().toUpperCase() === 'SEM_OJC'
                    ? 'Sem OJC cadastrado'
                    : item.trim()
            );
    }

    return processos.filter(proc => {
        const sigla = proc.orgaoJulgadorColegiado?.sigla?.trim();
        return listaOjc.includes(sigla);
    });
}
